import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { getForceChangePassword, isTokenValid } from "../../../../app/services/auth.service";
import { Content } from "./Content";
import { useSubheader } from "../../_core/MetronicSubheader";

export function ContentRoute({ children, label, component, render, ...props }) {
  const tokenValidation = isTokenValid();

  // Subheader
  // const subHeader = useSubheader();
  // if (label !== undefined)
  //   subHeader.setTitle(label);

  //subheader.setBreadcrumbs(breadCrumbs);

  if (tokenValidation && !getForceChangePassword()) {
    // if (performance.navigation.type ===1 1) {
    //   // page was just refreshed:
    //   //window.location.href = '/loan-list';
    //   return <Redirect to="/loan-list" />
    // } else {
    return (
      <Route {...props}>

        {(routeProps) => {

          if (typeof children === "function") {
            return <Content>{children(routeProps)}</Content>;
          }

          if (!routeProps.match) {
            return null;
          }

          if (children) {
            return <Content>{children}</Content>;
          }

          if (component) {
            return (
              <Content>{React.createElement(component, routeProps)}</Content>
            );
          }

          if (render) {
            return <Content>{render(routeProps)}</Content>;
          }

          return null;
        }}
      </Route>
    );
    //}
  }
  else if (tokenValidation && getForceChangePassword()) {
    return <Redirect exact to="/forceChangePass" />
  }
  else {
    return <Redirect exact to="/login" />
  };
}
